<script lang="ts">

    import { tick } from 'svelte';
    import { scrollTopMainRoute } from '../scripts/common';

    tick().then(() => {
        scrollTopMainRoute();
    })

</script>

<style lang="scss">
</style>

<div class="pagemobile">
    <img class="pagemobile__image" src="../assets/images/jacqueline_fardel.jpg" alt="Jacqueline Fardel">
    <p class="pagemobile__textcontent pagemobile__text">
        Je suis Jacqueline Fardel<br>
        Journaliste à Radio France, pratiquante et enseignante de yoga
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        Entre ces deux univers, que tout pourrait opposer, il y a pour moi un lien puissant : la respiration. 
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        Le souffle intérieur. Le souffle du monde.
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        Et ce chemin de l'un à l'autre.
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        Les podcasts que je vous propose ici, veulent porter cette inspiration, dans les deux sens du terme : l'air nouveau, entré par les narines – et ici par les oreilles- qui nourrit, aère le corps et l'esprit, et la veine stimulante qui circule, nous enthousiasme ou nous révolte, nous porte, nous permet les pas de côté.
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        Il ne s'agit pas ici de leçons de yoga. Encore moins de leçons de vie ou de morale.
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        Il ne s'agit pas non plus d'analyse de l'évolution du yoga, de recettes magiques ou de développement personnel.
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        Il s'agit de relier.
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        C'est la signification même du mot « yoga » terme intact du sanskrit Yuj, unir
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        C'est à mon sens aussi le rôle du journalisme, de dresser des ponts entre les mondes, de les ouvrir, de les donner à entendre.
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        Un pied dans les deux univers, c'est le lien que je me propose de tisser . Le fil de l'écoute. Au sens japonais du terme, langage dans lequel le verbe « écouter » signifie également demander, questionner, sentir, apprendre quelque chose. «  Ce mot implique donc une mobilisation complète des sens, une qualité d'être et de présence » ( Tozan )
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        Le Guetteur Yoga se veut un espace vivant, de reportages, de rencontres, de témoignages des mondes du yoga, de sa pratique à son exploitation, de ses voyages à ses dérives. La lumière et l'ombre. Tout ce qui fait du yoga une matière vivante du XXIè siècle, dont chacun s'empare à sa façon.
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        Face aux différents visages du yoga aujourd'hui, ma volonté ici n'est pas de me poser en juge, mais bien plus en observatrice, en témoin. L'objet n'est pas de faire la promotion d'un bon yoga ou à l'inverse de dénoncer un mauvais yoga, mais de voir ce qu'il dit de notre société, de nous-mêmes, de quelles histoires il vient nous parler.
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        Par le son, la parole, la vibration, l'écran large de la radio, et en me laissant guider par cette « école de déconditionnement » qu'est le yoga qu'on m'a transmis, je veux faire vivre ces podcasts, ce Guetteur-Yoga, comme un veilleur qui ouvre les yeux sur les aspects cachés, les illusions, les trésors propres à chacun.
    </p>
    <p class="pagemobile__textcontent pagemobile__text">
        Le Guetteur, celui qui est témoin, celui qui est à l'affût, celui qui prend soin du karana, le mouvement de la vie. Le Guetteur Yoga vous invite à accueillir sa résonance.                    
    </p>
</div>

<div class="pageScroll">
    <div class="pageScroll__content">
        <div class="pageScroll__scroll">
            <div class="pageScroll__parallax">
                <img class="pageScroll__image" src="../assets/images/jacqueline_fardel.jpg" alt="Jacqueline Fardel">
            </div>
            <div class="pageScroll__vu">
                <p class="pageScroll__text">
                    Je suis Jacqueline Fardel<br>
                    Journaliste à Radio France, pratiquante et enseignante de yoga
                </p>
                <p class="pageScroll__text">
                    Entre ces deux univers, que tout pourrait opposer, il y a pour moi un lien puissant : la respiration. 
                </p>
                <p class="pageScroll__text">
                    Le souffle intérieur. Le souffle du monde.
                </p>
                <p class="pageScroll__text">
                    Et ce chemin de l'un à l'autre.
                </p>
                <p class="pageScroll__text">
                    Les podcasts que je vous propose ici, veulent porter cette inspiration, dans les deux sens du terme : l'air nouveau, entré par les narines – et ici par les oreilles- qui nourrit, aère le corps et l'esprit, et la veine stimulante qui circule, nous enthousiasme ou nous révolte, nous porte, nous permet les pas de côté.
                </p>
                <p class="pageScroll__text">
                    Il ne s'agit pas ici de leçons de yoga. Encore moins de leçons de vie ou de morale.
                </p>
                <p class="pageScroll__text">
                    Il ne s'agit pas non plus d'analyse de l'évolution du yoga, de recettes magiques ou de développement personnel.
                </p>
                <p class="pageScroll__text">
                    Il s'agit de relier.
                </p>
                <p class="pageScroll__text">
                    C'est la signification même du mot « yoga » terme intact du sanskrit Yuj, unir
                </p>
                <p class="pageScroll__text">
                    C'est à mon sens aussi le rôle du journalisme, de dresser des ponts entre les mondes, de les ouvrir, de les donner à entendre.
                </p>
                <p class="pageScroll__text">
                    Un pied dans les deux univers, c'est le lien que je me propose de tisser . Le fil de l'écoute. Au sens japonais du terme, langage dans lequel le verbe « écouter » signifie également demander, questionner, sentir, apprendre quelque chose. «  Ce mot implique donc une mobilisation complète des sens, une qualité d'être et de présence » ( Tozan )
                </p>
                <p class="pageScroll__text">
                    Le Guetteur Yoga se veut un espace vivant, de reportages, de rencontres, de témoignages des mondes du yoga, de sa pratique à son exploitation, de ses voyages à ses dérives. La lumière et l'ombre. Tout ce qui fait du yoga une matière vivante du XXIè siècle, dont chacun s'empare à sa façon.
                </p>
                <p class="pageScroll__text">
                    Face aux différents visages du yoga aujourd'hui, ma volonté ici n'est pas de me poser en juge, mais bien plus en observatrice, en témoin. L'objet n'est pas de faire la promotion d'un bon yoga ou à l'inverse de dénoncer un mauvais yoga, mais de voir ce qu'il dit de notre société, de nous-mêmes, de quelles histoires il vient nous parler.
                </p>
                <p class="pageScroll__text">
                    Par le son, la parole, la vibration, l'écran large de la radio, et en me laissant guider par cette « école de déconditionnement » qu'est le yoga qu'on m'a transmis, je veux faire vivre ces podcasts, ce Guetteur-Yoga, comme un veilleur qui ouvre les yeux sur les aspects cachés, les illusions, les trésors propres à chacun.
                </p>
                <p class="pageScroll__text">
                    Le Guetteur, celui qui est témoin, celui qui est à l'affût, celui qui prend soin du karana, le mouvement de la vie. Le Guetteur Yoga vous invite à accueillir sa résonance.                    
                </p>
            </div>
        </div>
    </div>
</div>
